import * as React from "react";
import classnames from 'classnames';

import {ll_url} from '../tools';

export interface IBoxProps {
    title: string,
    button?: React.ReactNode,
    intro?: boolean,
    className?: string,
    children?: React.ReactNode,
    width?: string,
    selected?: boolean,
    onClick?: any,
    image?: string,
    height?:string,
    // structureData?: boolean,
}

function status(selected) {
    return selected? <img src = {ll_url("/images/accept.png")} style = {{height: "23px", width:"23px", position: "absolute", right: "17px"}}/> : <img src = {ll_url("/images/disable.png")} style = {{height: "23px", width:"23px", position: "absolute", right: "17px"}}/>;
}

const Box = (props: IBoxProps) => (
    <div className="ll-box no-select" style={{width: props.width}} >
        <div className="ll-box-title" onClick = {props.onClick}>
         {props.selected!=null? status(props.selected):null} 
        <h2  id={props.title.replace(/\W+/g, '_').toLowerCase()}>
            {props.title}
            
        </h2>  

        {props.button}
        </div>
        
        <div
            className={classnames('ll-box-content', {'ll-box-intro': props.intro === true}, props.className)}
        >
            {props.children}
        </div>
    </div>
);

export default Box;
